import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ModelosColecaoViewModel, ConsultarModelosColecaoViewModel, ConsultarModelosColecaoCoresViewModel, ConsultarModelosColecaoGradesViewModel, ModelosColecaoCoresViewModel, ModelosColecaoGradesViewModel, ModelosColecaoPecasViewModel, ConsultarModelosColecaoPecasViewModel } from '../../models/confeccoes/ModelosColecaoViewModel';
import { ConsultaPaginadaViewModel } from '../../model/model.api';
import { ConsultaModeloColecaoPecasResponseViewModel, ConsultaPecasViewModel } from 'models/confeccoes/PecaViewModel';
import { List } from '@amcharts/amcharts4/core';

@Injectable()
export class ModelosColecaoServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('ModelosColecao', http);
  }

  consultarModelosColecao(payload: ConsultarModelosColecaoViewModel) {
    return this.postPaginatedAsPromise<ConsultarModelosColecaoViewModel, ConsultaPaginadaViewModel<ModelosColecaoViewModel>>(payload, 'consultarModelosColecao');
  }

  consultarModelosColecaoCores(payload: ConsultarModelosColecaoCoresViewModel) {
    return this.postPaginatedAsPromise<ConsultarModelosColecaoCoresViewModel, ConsultaPaginadaViewModel<ModelosColecaoCoresViewModel>>(payload, 'consultarModelosColecaoCores')
  }

  consultarModelosColecaoGrades(payload: ConsultarModelosColecaoGradesViewModel) {
    return this.postPaginatedAsPromise<ConsultarModelosColecaoGradesViewModel, ConsultaPaginadaViewModel<ModelosColecaoGradesViewModel>>(payload, 'consultarModelosColecaoGrades')
  }

  consultarModelosColecaoPecas(payload: ConsultarModelosColecaoPecasViewModel) {
    return this.postPaginatedAsPromise<ConsultarModelosColecaoPecasViewModel, ConsultaPaginadaViewModel<ConsultaPecasViewModel>>(payload, 'consultaModeloColecaoPecasPaginada/' + payload.modeloColecaoID)
  }

  modeloColecaoQuantidadePecasSemCadastro(modeloColecaoID: number) {
    return this.getAsPromise<List<ConsultaModeloColecaoPecasResponseViewModel>>('modeloColecaoQuantidadePecasSemCadastro/' + modeloColecaoID);
  }

  atualizarDadosFiscaisItens(modeloColecaoID: number,) {
    return this.postAsPromise<ModelosColecaoPecasViewModel[], void>(null, `atualizarDadosFiscaisItens/${modeloColecaoID}`);
  }

}